"use client";

import Link from "next/link";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";

const GlobePath = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    if (!containerRef.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: "300px" }
    );

    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="bg-[#021A38] mt-[48px] sm:mt-[72px] md:mt-[80px] lg:mt-[100px] xl:mt-[120px] py-[32px] xl:py-0 px-4 xxs:px-6 sm:px-[40px]">
      <div className="container max-w-[1400px] mx-auto flex items-center flex-col lg:flex-row justify-between">
        <div className="max-w-[710px]">
          <p className="mb-2 sm:mb-4 md:mb-6 lg:mb-7 xl:mb-8 text-center lg:text-start font-semibold text-[24px] xxs:text-[34px] sm:text-[36px] md:text-[38px] lg:text-[40px] xl:text-[42px] text-white leading-[1.3]">
            We cover more than 20+ <br className="hidden sm:block" /> countries for you
          </p>
          <p className="ff_poppins mb-2 sm:mb-4 md:mb-6 lg:mb-7 xl:mb-8 text-center lg:text-start font-medium text-base sm:text-[20px]  text-white">
            <span className="font-semibold !text-[18px] !sm:text-[24px]">850+
            </span>
            {" "}Universities
            | <span className="font-semibold !text-[18px] !sm:text-[24px]">
              Available
            </span>
            {" "}Programs
          </p>
          <Link
            href="/all-countries"
            className="rounded-full bg-primary-gradient text-white text-xl ff_poppins font-semibold py-[16px] px-[30px] lg:inline-block hidden overflow-hidden shinyAnimation relative before:bg-shiny-gradient before:content-[''] before:h-[200%] before:absolute before:top-[-55%] before:z-0 before:rotate-[-80deg] before:w-[90px] before:right-[calc(100%+20px)] hover:scale-[1.05] focus:scale-[1.05] duration-300 ease-in-out"
          >
            Explore All Countries
          </Link>
        </div>
        <div
          ref={containerRef}
          className="max-w-[570px] w-full isolate relative aspect-square flex items-center justify-center"
        >
          {isInView ? (
            <Image
              src="/assets/gif/homeGlobe.gif"
              alt="globe"
              width={570}
              height={570}
              className="w-full h-auto"
              unoptimized
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center opacity-20">
              <div className="w-48 h-48 rounded-full border border-blue-400/30 animate-pulse" />
            </div>
          )}
        </div>
        <Link
          href="/all-countries"
          className="rounded-full text-center bg-primary-gradient text-white text-lg mt-6 w-full lg:text-xl ff_poppins font-semibold py-[10px] px-[30px] inline-block lg:hidden shinyAnimation overflow-hidden relative before:bg-shiny-gradient before:content-[''] before:h-[200%] before:absolute before:top-[-55%] before:z-0 before:rotate-[-80deg] before:w-[90px] before:right-[calc(100%+20px)] hover:scale-[1.05] focus:scale-[1.05] duration-300 ease-in-out"
        >
          Explore All Countries
        </Link>
      </div>
    </div>
  );
};
export default GlobePath;
